import { nextgenApiClient } from '../client';

export function me() {
  return nextgenApiClient
    .get('/api/accounts/me', {
      params: {
        includeUserdetails: true,
      },
    })
    .then(({ data }) => data);
}
